/* eslint-disable */
import Link from 'next/link';

export const DgNewEximNote = () => {
  return (
    <p className="text--gray text--regular pledge__info dg-new-note-text">
      <span className="text--darkBlue text--bold">Note:</span> You will be
      purchasing gold of{' '}
      <span className="dg-new-note-text-bold">24K | 99.9% purity</span>
      <br />
      <br />
      eSwarna Digital Gold offered on Muthoot FinCorp ONE is provided by Muthoot Exim
      Pvt. Ltd. Upon clicking 'Buy Now' you agree to the{' '}
      <Link href="/terms-and-conditions" className="dg-new-note-text-hyperlink">
        terms & conditions
      </Link>{' '}
      offered of Muthoot Exim Pvt. Ltd.
    </p>
  );
};
